import React, { useEffect, useState } from "react";
import Footer from "../../components/Footer";
import Navbar from "../../components/Navbar";
import { lambda } from "../../Functions";

function Settings() {
  const [userData, setUserData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [editedData, setEditedData] = useState(null);
  const [isEdited, setIsEdited] = useState(false);
  const [isSaving, setIsSaving] = useState(false); // Loader state

  useEffect(() => {
    const data = sessionStorage.getItem("gbx_data");
    if (data) {
      setUserData(JSON.parse(data));
      setEditedData(JSON.parse(data));
    }
    setLoading(false);
  }, []);

  const handleInputChange = (e, field) => {
    let value = e.target.value;

    // Allow only numeric values for phone field
    if (field === "phone") {
      value = value.replace(/\D/g, ""); // Remove non-numeric characters
    }

    setEditedData(prevData => ({
      ...prevData,
      user: { ...prevData.user, [field]: value }
    }));

    setIsEdited(true);
  };

  const handleSave = async () => {
    if (!editedData || !editedData.user) return;

    setIsSaving(true); // Start loader

    sessionStorage.setItem("gbx_data", JSON.stringify(editedData));

    const requestData = {
      id: editedData.user.id,
      email: editedData.user.email,
      firstName: editedData.user.first_name,
      lastName: editedData.user.last_name,
      phone: editedData.user.phone,
    };

    try {
      const response = await fetch(`${lambda}?action=EditUser`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(requestData),
      });

      const data = await response.json();

      if (data.success) {
        setIsEdited(false);
        alert("User data saved successfully!");
      } else {
        alert("Error saving user data.");
      }
    } catch (error) {
      console.error("Error while saving user data:", error);
      alert("An error occurred while saving user data.");
    } finally {
      setIsSaving(false); // Stop loader
    }
  };

  if (loading) {
    return <div className="loader">Loading...</div>;
  }

  if (!userData || !userData.user) {
    return <div>No user data found.</div>;
  }

  return (
    <div>
      <Navbar />

      <section className="container" style={{ marginTop: "100px" }}>
        <h2>Settings</h2>
        <div>
          <div className="row">
            <div className="col-lg-6">
              <div className="d-flex flex-column">
                <label className="bold mt-2">First Name</label>
                <input
                  className="bg-input"
                  value={editedData.user.first_name || ""}
                  onChange={(e) => handleInputChange(e, "first_name")}
                />
              </div>
            </div>

            <div className="col-lg-6">
              <div className="d-flex flex-column">
                <label className="bold mt-2">Last Name</label>
                <input
                  className="bg-input"
                  value={editedData.user.last_name || ""}
                  onChange={(e) => handleInputChange(e, "last_name")}
                />
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-lg-6">
              <div className="d-flex flex-column">
                <label className="bold mt-2">Email Address</label>
                <input
                  className="bg-input"
                  value={editedData.user.email || ""}
                  onChange={(e) => handleInputChange(e, "email")}
                />
              </div>
            </div>

            <div className="col-lg-6">
              <div className="d-flex flex-column">
                <label className="bold mt-2">Phone Number</label>
                <input
                  className="bg-input"
                  value={editedData.user.phone || ""}
                  onChange={(e) => handleInputChange(e, "phone")}
                />
              </div>
            </div>
          </div>
        </div>

        {isEdited && (
          <div className="mt-3">
            <button
              className="bg_purple br_10 save-button"
              style={{
                fontSize: "1.6rem",
                color: "white",
                border: "1px solid rgba(63, 44, 139, 0.03)",
                padding: "1rem 2rem",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: "10px",
              }}
              onClick={handleSave}
              disabled={isSaving} // Disable button while saving
            >
              {isSaving ? (
                <>
                  <div className="spinner"></div>
                  Saving...
                </>
              ) : (
                "Save"
              )}
            </button>
          </div>
        )}
      </section>

      <Footer />
    </div>
  );
}

export default Settings;
